/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CreateProjectActions, CreateProjectActionTypes, OpenCreateProjectOverlayParams } from './types';

export const openCreateProjectOverlay = (params: OpenCreateProjectOverlayParams = {}): CreateProjectActionTypes => ({
  type: CreateProjectActions.OPEN_CREATE_PROJECT_OVERLAY,
  payload: params,
});

export const closeCreateProjectOverlay = (): CreateProjectActionTypes => ({
  type: CreateProjectActions.CLOSE_CREATE_PROJECT_OVERLAY,
});
